import { $d } from "../functions/DocumentCSS";

/*------- GWERH,THE BARD -------*/

//Tales

export function handlerTaleOnClick(f,e){
    f(e)
}

export function handlerTaleOnMouseEnter(f,e){
    f(e)
    $d('._tales_').style.scale='1'
    $d('._tales_').style.opacity='1'
    $d('._tales_').style.transitionDuration='0.5s'
}

export function handlerTaleOnMouseLeave(){
    $d('._tales_').style.scale='0'
    $d('._tales_').style.opacity='0'
    $d('._tales_').style.transitionDuration='0.5s'
}

//Interactions

export function handlerInteractOnClick(e){
    if(e==='Interactuar') {
        $d('.gwerh_btn_interact_on').style.display='block'
        $d('.gwerh_btn_interact_on').style.opacity='1'
        $d('.gwerh_btn_interact').style.display='none'
        $d('.gwerh_btn_tales').style.transitionDuration="0.5s"
        $d('.gwerh_btn_tales').style.scale="1"
        $d('.gwerh_btn_tales').style.opacity="1"
        $d('.gwerh_btn_tales').style.transform="translate(-200px,75px)"
        $d('.gwerh_btn_quest').style.transitionDuration="1s"
        $d('.gwerh_btn_quest').style.scale="1"
        $d('.gwerh_btn_quest').style.opacity="1"
        $d('.gwerh_btn_quest').style.transform="translate(-150px,200px)"
        $d('.gwerh_btn_contact').style.transitionDuration="1.5s"
        $d('.gwerh_btn_contact').style.scale="1"
        $d('.gwerh_btn_contact').style.opacity="1"
        $d('.gwerh_btn_contact').style.transform="translateY(250px)"
        $d('.gwerh_btn_opciones').style.transitionDuration="2s"
        $d('.gwerh_btn_opciones').style.scale="1"
        $d('.gwerh_btn_opciones').style.opacity="1"
        $d('.gwerh_btn_opciones').style.transform="translate(150px,200px)"
        $d('.gwerh_btn_whoru').style.transitionDuration="2.5s"
        $d('.gwerh_btn_whoru').style.scale="1"
        $d('.gwerh_btn_whoru').style.opacity="1"
        $d('.gwerh_btn_whoru').style.transform="translate(200px,75px)"
        $d('.gwerh_cont_interact').style.transitionDuration="1s"
        $d('.gwerh_cont_interact').style.transform="translate(-100px,100px)"
    }
    if(e==='Gwerh'){
        $d('.gwerh_btn_interact_on').style.display='none'
        $d('.gwerh_btn_interact').style.display='block'
        $d('.gwerh_btn_tales').style.display='block'
        $d('.gwerh_btn_tales').style.transitionDuration="1s"
        $d('.gwerh_btn_tales').style.scale="0"
        $d('.gwerh_btn_tales').style.opacity="0"
        $d('.gwerh_btn_tales').style.transform="translate(0)"
        $d('.gwerh_btn_whoru').style.transitionDuration="1s"
        $d('.gwerh_btn_whoru').style.scale="0"
        $d('.gwerh_btn_whoru').style.opacity="0"
        $d('.gwerh_btn_whoru').style.transform="translate(0)"
        $d('.gwerh_btn_quest').style.transitionDuration="1s"
        $d('.gwerh_btn_quest').style.scale="0"
        $d('.gwerh_btn_quest').style.opacity="0"
        $d('.gwerh_btn_quest').style.transform="translate(0)"
        $d('.gwerh_btn_contact').style.transitionDuration="1s"
        $d('.gwerh_btn_contact').style.scale="0"
        $d('.gwerh_btn_contact').style.opacity="0"
        $d('.gwerh_btn_contact').style.transform="translate(0)"
        $d('.gwerh_btn_opciones').style.transitionDuration="1s"
        $d('.gwerh_btn_opciones').style.scale="0"
        $d('.gwerh_btn_opciones').style.opacity="0"
        $d('.gwerh_btn_opciones').style.transform="translate(0)"
        $d('.gwerh_cont_interact').style.transform="translate(0,0)"     
        $d('.gwerh_cont_interact').style.transitionDuration="0.5s"
    }
    if(e==='Tales'){
        $d('.lista').style.transitionDuration="1s"
        $d('.lista').style.transform="translate(0)"
        $d('.gwerh_cont_interact').style.opacity="1"
        $d('.gwerh_btn_tales').style.transitionDuration="1s"
        $d('.gwerh_btn_tales').style.opacity="1"
        $d('.gwerh_btn_quest').style.transitionDuration="1s"
        $d('.gwerh_btn_quest').style.opacity="0.5"
        $d('.gwerh_btn_whoru').style.transitionDuration="1s"
        $d('.gwerh_btn_whoru').style.opacity="0.5"
        $d('.gwerh_btn_opciones').style.transitionDuration="1s"
        $d('.gwerh_btn_opciones').style.opacity="0.5"
        $d('.gwerh_btn_contact').style.transitionDuration="1s"
        $d('.gwerh_btn_contact').style.opacity="0.5"
    }
    if(e==='Quest'){
        $d('.lista').style.transitionDuration="1s"
        $d('.lista').style.transform="translate(-300px)"
        $d('.gwerh_btn_tales').style.transitionDuration="1s"
        $d('.gwerh_btn_tales').style.opacity="0.5"
        $d('.gwerh_btn_quest').style.transitionDuration="1s"
        $d('.gwerh_btn_quest').style.opacity="1"
        $d('.gwerh_btn_contact').style.transitionDuration="1s"
        $d('.gwerh_btn_contact').style.opacity="0.5"
        $d('.gwerh_btn_opciones').style.transitionDuration="1s"
        $d('.gwerh_btn_opciones').style.opacity="0.5"
        $d('.gwerh_btn_whoru').style.transitionDuration="1s"
        $d('.gwerh_btn_whoru').style.opacity="0.5"
        $d('.lista').style.transitionDuration="1s"
        $d('.lista').style.transform="translate(-300px)"    
    }
    if(e==='Who are you?'){
        $d('.lista').style.transitionDuration="1s"
        $d('.lista').style.transform="translate(-300px)"
        $d('.gwerh_btn_tales').style.transitionDuration="1s"
        $d('.gwerh_btn_tales').style.opacity="0.5"
        $d('.gwerh_btn_quest').style.transitionDuration="1s"
        $d('.gwerh_btn_quest').style.opacity="0.5"
        $d('.gwerh_btn_contact').style.transitionDuration="1s"
        $d('.gwerh_btn_contact').style.opacity="0.5"
        $d('.gwerh_btn_opciones').style.transitionDuration="1s"
        $d('.gwerh_btn_opciones').style.opacity="0.5"
        $d('.gwerh_btn_whoru').style.transitionDuration="1s"
        $d('.gwerh_btn_whoru').style.opacity="1"
        $d('.lista').style.transitionDuration="1s"
        $d('.lista').style.transform="translate(-300px)"
    }
    if(e==='Contact'){
        $d('.lista').style.transitionDuration="1s"
        $d('.lista').style.transform="translate(-300px)"
        $d('.gwerh_btn_tales').style.transitionDuration="1s"
        $d('.gwerh_btn_tales').style.opacity="0.5"
        $d('.gwerh_btn_quest').style.transitionDuration="1s"
        $d('.gwerh_btn_quest').style.opacity="0.5"
        $d('.gwerh_btn_contact').style.transitionDuration="1s"
        $d('.gwerh_btn_contact').style.opacity="1"
        $d('.gwerh_btn_opciones').style.transitionDuration="1s"
        $d('.gwerh_btn_opciones').style.opacity="0.5"
        $d('.gwerh_btn_whoru').style.transitionDuration="1s"
        $d('.gwerh_btn_whoru').style.opacity="0.5"
        $d('.lista').style.transitionDuration="1s"
        $d('.lista').style.transform="translate(-300px)"
    }
    if(e==='Configuration'){
        $d('.lista').style.transitionDuration="1s"
        $d('.lista').style.transform="translate(-300px)"
        $d('.gwerh_btn_tales').style.transitionDuration="1s"
        $d('.gwerh_btn_tales').style.opacity="0.5"
        $d('.gwerh_btn_quest').style.transitionDuration="1s"
        $d('.gwerh_btn_quest').style.opacity="0.5"
        $d('.gwerh_btn_contact').style.transitionDuration="1s"
        $d('.gwerh_btn_contact').style.opacity="0.5"
        $d('.gwerh_btn_opciones').style.transitionDuration="1s"
        $d('.gwerh_btn_opciones').style.opacity="1"
        $d('.gwerh_btn_whoru').style.transitionDuration="1s"
        $d('.gwerh_btn_whoru').style.opacity="0.5"
    }

}

export function handlerInteractOnMouseEnter(f,e,d){
    f(e)
    if(e==='Interactuar'){
    $d('._tales_').style.scale='1'
    $d('._tales_').style.opacity='1'
    $d('._tales_').style.transitionDuration='0.5s'
    $d('.gwerh_btn_interact').style.transitionDuration="1s"
    $d('.gwerh_btn_interact').style.filter="brightness(1.2)"
    $d('.gwerh_btn_interact').style.animationName="none"
    $d('.gwerh_btn_interact').style.scale="1.2"
    }
    if(e==='Gwerh'){
    $d('._tales_').style.scale='1'
    $d('._tales_').style.opacity='1'
    $d('._tales_').style.transitionDuration='0.5s'
    $d('.gwerh_btn_interact_on').style.transitionDuration="1s"
    $d('.gwerh_btn_interact_on').style.filter="brightness(1.2)"
    $d('.gwerh_btn_interact_on').style.animationName="none"
    $d('.gwerh_btn_interact_on').style.scale="1.2"     
    }
    if(e==='Tales'){
    $d('._tales_').style.scale='1'
    $d('._tales_').style.opacity='1'
    $d('._tales_').style.transitionDuration='0.5s'
    $d('.gwerh_btn_tales').style.transitionDuration="1s"
    $d('.gwerh_btn_tales').style.filter="brightness(1.2)"
    }
    if(e==='Quest'){
        $d('._tales_').style.scale='1'
        $d('._tales_').style.opacity='1'
        $d('._tales_').style.transitionDuration='0.5s'
        $d('.gwerh_btn_quest').style.transitionDuration="1s"
        $d('.gwerh_btn_quest').style.filter="brightness(1.2)"
    }
    if(e==='Who are you?'){
        $d('._tales_').style.scale='1'
        $d('._tales_').style.opacity='1'
        $d('._tales_').style.transitionDuration='0.5s'
        $d('.gwerh_btn_whoru').style.transitionDuration="1s"
        $d('.gwerh_btn_whoru').style.filter="brightness(1.2)"
    }
    if(e==='Contact'){
        $d('._tales_').style.scale='1'
        $d('._tales_').style.opacity='1'
        $d('._tales_').style.transitionDuration='0.5s'
        $d('.gwerh_btn_contact').style.transitionDuration="1s"
        $d('.gwerh_btn_contact').style.filter="brightness(1.2)"
    }
    if(e==='Configuration'){
        $d('._tales_').style.scale='1'
        $d('._tales_').style.opacity='1'
        $d('._tales_').style.transitionDuration='0.5s'
        $d('.gwerh_btn_opciones').style.transitionDuration="1s"
        $d('.gwerh_btn_opciones').style.filter="brightness(1.2)"
    }
}

export function handlerInteractOnMouseLeave(e){
    if(e==='Interactuar'){
        $d('.gwerh_btn_interact').style.transitionDuration="1s"
        $d('.gwerh_btn_interact').style.filter="brightness(1)"
        $d('._tales_').style.scale='0'
        $d('._tales_').style.opacity='0'
        $d('._tales_').style.transitionDuration='0.5s'
        $d('.gwerh_btn_interact').style.animationName="Floatingx"
        $d('.gwerh_btn_interact').style.scale="1"
    }
    if(e==='Gwerh'){
        $d('.gwerh_btn_interact_on').style.transitionDuration="1s"
        $d('.gwerh_btn_interact_on').style.filter="brightness(1)"
        $d('._tales_').style.scale='0'
        $d('._tales_').style.opacity='0'
        $d('._tales_').style.transitionDuration='0.5s'
        $d('.gwerh_btn_interact_on').style.animationName="Floatingx"
        $d('.gwerh_btn_interact_on').style.scale="1"
    }
    if(e==='Tales'){
        $d('.gwerh_btn_tales').style.transitionDuration="1s"
        $d('.gwerh_btn_tales').style.filter="brightness(1)"
        $d('._tales_').style.scale='0'
        $d('._tales_').style.opacity='0'
        $d('._tales_').style.transitionDuration='0.5s'
    }
    if(e==='Quest'){
        $d('.gwerh_btn_quest').style.transitionDuration="1s"
        $d('.gwerh_btn_quest').style.filter="brightness(1)"
        $d('._tales_').style.scale='0'
        $d('._tales_').style.transitionDuration='0.5s'
    
    }
    if(e==='Who are you?'){
        $d('.gwerh_btn_whoru').style.transitionDuration="1s"
        $d('.gwerh_btn_whoru').style.filter="brightness(1)"
        $d('._tales_').style.scale='0'
        $d('._tales_').style.transitionDuration='0.5s'
    }
    if(e==='Contact'){
        $d('.gwerh_btn_contact').style.transitionDuration="1s"
        $d('.gwerh_btn_contact').style.filter="brightness(1)"
        $d('._tales_').style.scale='0'
        $d('._tales_').style.opacity='0'
        $d('._tales_').style.transitionDuration='0.5s'
    }
    if(e==='Configuration'){
        $d('.gwerh_btn_opciones').style.transitionDuration="1s"
        $d('.gwerh_btn_opciones').style.filter="brightness(1)"
        $d('._tales_').style.scale='0'
        $d('._tales_').style.opacity='0'
        $d('._tales_').style.transitionDuration='0.5s'
    }
}